import { useMemo } from 'react';

import { useGetFace, useGetLists } from '@vlabs/api/artemy/client';
import { proxyArtemyUrl } from '@vlabs/api/axios/point2-client';
import { isUUID } from '@vlabs/shared/validators';

export const useMatchData = (matchData) => {
  const faceId = matchData?.face_id;
  const label = matchData?.label;
  const isListLabel = !!label && isUUID(label);

  const getFace = useGetFace(faceId ?? '', undefined, {
    query: { enabled: !!faceId },
  });
  const getLists = useGetLists(
    { list_ids: isListLabel ? [label] : [] },
    { query: { enabled: isListLabel } },
  );

  const match = useMemo(() => {
    if (!getFace.data) return undefined;

    const result = {
      uiAvatarUrl: proxyArtemyUrl(getFace.data.avatar),
    };

    if (!isListLabel) {
      return {
        ...result,
        label,
      };
    }

    const list = getLists.data?.lists?.find(({ list_id: listId }) => listId === label);

    return {
      ...result,
      listId: label,
      listLabel: list?.user_data,
    };
  }, [getFace.data, getLists.data?.lists, isListLabel, label]);

  return match;
};
